import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function downloadDocsNEO (data = {}, params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getLanguages.data)
      }, 500)
    })
  } else {
    const req = {
      url: '/api/adjuntos/downloadzip',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      // responseType: 'blob',
      data,
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { downloadDocsNEO }
